import React, { FC, MouseEventHandler } from 'react';

import Button from '../../common/Button';
import Modal, { IModalProps } from '../Modal';

import * as S from './styles';

interface IProps extends Omit<IModalProps, 'children'> {
  description: string;
  confirmText: string;
  abortText: string;
  onConfirm?: MouseEventHandler<HTMLButtonElement>;
  onAbort?: MouseEventHandler<HTMLButtonElement>;
}

const Confirmation: FC<IProps> = ({
  description,
  confirmText,
  abortText,
  onConfirm,
  onAbort,
  ...modalProps
}) => (
  <Modal {...modalProps}>
    <S.Container>
      <S.Description>{description}</S.Description>
      <S.ButtonsContainer>
        <Button
          variant="outline"
          onClick={onConfirm}
          $size="large"
          $isRed
        >
          {confirmText}
        </Button>
        <Button
          variant="primary"
          onClick={onAbort}
          $size="large"
        >
          {abortText}
        </Button>
      </S.ButtonsContainer>
    </S.Container>
  </Modal>
);

export default Confirmation;
